import styled from '@emotion/styled';
import { Icon } from 'toolkit/components';

const StyledIcon = styled(Icon)`
  width: 100%;
`;

const LoadingSpinner = () => <StyledIcon type="spinner" spin="clockwise" />;

export default LoadingSpinner;
